import { render, staticRenderFns } from "./assess.vue?vue&type=template&id=31cd8bc8&scoped=true&"
import script from "./assess.vue?vue&type=script&lang=js&"
export * from "./assess.vue?vue&type=script&lang=js&"
import style0 from "./assess.vue?vue&type=style&index=0&id=31cd8bc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd8bc8",
  null
  
)

export default component.exports